import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const Footer = () => {
  return (
    <footer id="contato" className="bg-brand-ink text-brand-cream" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.3em] text-brand-terracotta mb-3">
              Atibaia · São Paulo
            </p>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tighter leading-[0.95] mb-6">
              Recanto dos<br />Pinheiros
            </h2>
            <p className="text-brand-cream/60 max-w-sm leading-relaxed">
              Chalés de luxo imersos na natureza, a apenas 60 km da capital paulista.
              Um refúgio de paz com vista para a Pedra Grande.
            </p>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cream/50 mb-6">
              Contato
            </h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-brand-terracotta mt-0.5 flex-shrink-0" />
                <span className="text-brand-cream/80">
                  Alameda Berilo — Jardim Estância Brasil,<br />Atibaia - SP, 12949-121
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-brand-terracotta flex-shrink-0" />
                <a href="https://wa.me/5511920017434" target="_blank" rel="noopener noreferrer"
                  className="text-brand-cream/80 hover:text-brand-cream" data-testid="footer-whatsapp">
                  (11) 92001-7434
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-brand-terracotta flex-shrink-0" />
                <a href="mailto:admrecantodopinheiros@gmail.com"
                  className="text-brand-cream/80 hover:text-brand-cream break-all" data-testid="footer-email">
                  admrecantodopinheiros@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cream/50 mb-6">
              Informações
            </h3>
            <ul className="space-y-4 text-sm text-brand-cream/80">
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-brand-terracotta flex-shrink-0" />
                Atendimento todos os dias
              </li>
              <li>CNPJ: 47.334.396/0001-77</li>
              <li>Permitido animais de estimação</li>
              <li>Acesso exclusivo e controlado</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-cream/15 mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-brand-cream/40">
            © {new Date().getFullYear()} Recanto dos Pinheiros. Todos os direitos reservados.
          </p>
          <p className="text-xs text-brand-cream/40 uppercase tracking-[0.2em]">
            Refúgio na natureza
          </p>
        </div>
      </div>
    </footer>
  );
};
